export type AnalyticsEvent =
  | { name: 'cta_click'; cta_id: string; page_path: string }
  | { name: 'lead_form_start'; form_type: string }
  | { name: 'lead_form_submit_success'; form_type: string }
  | { name: 'lead_form_submit_error'; form_type: string; category: 'validation' | 'rate_limit' | 'network' | 'server' }
  | { name: 'phone_click' | 'whatsapp_click' | 'email_click' }
  | { name: 'product_interest'; product_key: string }
  | { name: 'article_cta_click' };

// DEC-021 selects "None at launch". This boundary intentionally performs no
// network or storage operation. A future approved provider may be connected here
// only after consent/privacy review and must accept this allowlisted shape.
export function track(event: AnalyticsEvent): void {
  window.dispatchEvent(new CustomEvent('tripsoft:analytics', { detail: event }));
}
